import { render, staticRenderFns } from "./deviceDetailDialog.vue?vue&type=template&id=64448498&scoped=true"
import script from "./deviceDetailDialog.vue?vue&type=script&lang=js"
export * from "./deviceDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64448498",
  null
  
)

export default component.exports